
import React from 'react'
import {  Typography,Box} from '@mui/material'

import { useStyles } from './IdentityValidationStyles'
import { UseImage ,Buttons,GenericDialog } from '../../components'

export function HelpForm(props) {
    const localStyles = useStyles()

    const title =
        props.inputName === 'CIC'
            ? 'Código de Identificación de credencial, CIC'
            : props.inputName === 'OCR'
                ? 'Número identificador OCR'
                : props.inputName === 'Año de emisión'
                    ? 'Año de emisión'
                    : props.inputName === 'Número de emisión'
                        ? 'Número de emisión'
                        : props.inputName === 'Año de registro'
                            ? 'Año de registro'
                            : props.inputName === 'Vigencia'
                                ? 'Año de Vigencia'
                                : ''

    const firstP =
        props.inputName === 'CIC'
            ? 'Este dato consta de 9 dígitos y lo puedes encontrar al reverso de tu credencial del elector; ubicado en la parte inferior izquierda debajo de la firma y huella digital, después de el código IDMEX.'
            : props.inputName === 'OCR'
                ? 'El número OCR consta de 13 dígitos y lo puedes encontrar al reverso de tu credencial de elector.'
                : props.inputName === 'Año de emisión'
                    ? 'Este dato consta de 4 dígitos y lo puedes encontrar al frente de tu credencial del elector.'
                    : props.inputName === 'Número de emisión'
                        ? 'Este dato consta de 2 dígitos y lo puedes encontrar al frente de tu credencial de elector.'
                        : props.inputName === 'Año de registro'
                            ? 'El año de registro consta de 4 dígitos y lo puedes encontrar al frente de tu credencial de elector.'
                            : props.inputName === 'Vigencia'
                                ? 'Este dato consta de 4 dígitos y lo puedes encontrar al frente de tu credencial del elector.'
                                : ''

    const secondP =
        props.inputName === 'CIC'
            ? ''
            : props.inputName === 'OCR'
                ? 'Para credenciales del 2008 ubicado en la parte izquierda y para credenciales de 2013 y posteriores en la parte inferior derecha, abajo de la firma del Secretario Ejecutivo del INE.'
                : props.inputName === 'Año de emisión'
                    ? 'Generalmente nombrado como EMISIÓN. Para credenciales del 2008 ubicado en la parte inferior izquierda y para credenciales de 2013 y posteriores en la parte inferior central.'
                    : props.inputName === 'Número de emisión'
                        ? 'Generalmente ubicada a un lado del año de registro. Para credenciales del 2008 ubicado en la parte central a un costado de la fotografía y para credenciales de 2013 y posteriores en la parte inferior derecha, debajo de la fotografía.'
                        : props.inputName === 'Año de registro'
                            ? 'Para credenciales del 2008 ubicado en la parte central a un costado de la fotografía y para credenciales de 2013 y posteriores en la parte inferior derecha, debajo de la fotografía.'
                            : props.inputName === 'Vigencia'
                                ? 'Generalmente nombrado como VIGENCIA. Para credenciales del 2008 ubicado en la parte inferior central y para credenciales de 2013 y posteriores en la parte inferior derecha.'
                                : ''

    const image =
        props.inputName === 'CIC'
            ? 'CIC.gif'
            : props.inputName === 'OCR'
                ? 'OCR.gif'
                : props.inputName === 'Año de emisión'
                    ? 'A_emision.gif'
                    : props.inputName === 'Número de emisión'
                        ? 'Emision.gif'
                        : props.inputName === 'Año de registro'
                            ? 'Registro.gif'
                            : props.inputName === 'Vigencia'
                                ? 'Vigencia.gif'
                                : ''

    return (<GenericDialog open={props.open} onClose={props.closeHelp}
        // title="Evidencia - Ubicación"
        content={<Box sx={{
          display: 'flex',
          position: 'relative',
          height: '80vh',
        }}>
                <div className={localStyles.textSection}>
                    <Typography variant="h6" className={localStyles.instructions}><b>{title}</b></Typography>
                    <Typography variant="subtitle1" className={localStyles.instructions}>{firstP}</Typography>
                    <Typography variant="subtitle1" className={localStyles.instructions}>{secondP}</Typography>
                </div>
                <UseImage src={image} className={localStyles.helpImg} />
       </Box>}
  />)
}